import styled from 'styled-components';
import { FaTimes } from 'react-icons/fa';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';

type LegendPanelProps = {
    isOpen: boolean;
    onClose: () => void;
};

export const LegendPanel = ({ isOpen, onClose }: LegendPanelProps) => {
    if (!isOpen) return null;

    return (
        <Overlay onClick={onClose}>
            <PanelContainer onClick={(e) => e.stopPropagation()}>
                <PanelHeader>
                    <PanelTitle>📖 Légende des pictogrammes</PanelTitle>
                    <CloseButton type="button" onClick={onClose}>
                        <FaTimes />
                    </CloseButton>
                </PanelHeader>

                <PanelContent>
                    <Section>
                        <SectionTitle>TYPE DE RÉASSORT</SectionTitle>
                        <LegendItem>
                            <Icon>🎯</Icon>
                            <Label>Stock cible (automatique)</Label>
                        </LegendItem>
                        <LegendItem>
                            <Icon>✋</Icon>
                            <Label>Réassort manuel (menus)</Label>
                        </LegendItem>
                        <LegendItem>
                            <Icon>🛢</Icon>
                            <Label>Réassort bac (recette machine à café)</Label>
                        </LegendItem>
                        <LegendItem>
                            <Icon>☕</Icon>
                            <Label>Réassort machine à café</Label>
                        </LegendItem>
                    </Section>

                    <Section>
                        <SectionTitle>PARAMÈTRES D'EMPLACEMENT</SectionTitle>
                        <LegendItem>
                            <Icon>🔄</Icon>
                            <Label>Rotation activée</Label>
                        </LegendItem>
                        <LegendItem>
                            <Icon>⏳</Icon>
                            <Label>Attendre épuisement du produit actuel</Label>
                        </LegendItem>
                        <LegendItem>
                            <Icon>⚡</Icon>
                            <Label>Commander en avance</Label>
                        </LegendItem>
                    </Section>

                    <Section>
                        <SectionTitle>ÉTAT</SectionTitle>
                        <LegendItem>
                            <Icon>📦</Icon>
                            <Label>Stock défini</Label>
                        </LegendItem>
                        <LegendItem>
                            <Icon>⚠️</Icon>
                            <Label>Configuration incomplète</Label>
                        </LegendItem>
                        <LegendItem>
                            <Icon>🔴</Icon>
                            <Label>Erreur de validation</Label>
                        </LegendItem>
                        <LegendItem>
                            <Icon>⚪</Icon>
                            <Label>Emplacement vide</Label>
                        </LegendItem>
                    </Section>
                </PanelContent>

                <PanelFooter>
                    <TotemPrimaryButton type="button" $isSecondaryStyle onClick={onClose}>
                        Fermer
                    </TotemPrimaryButton>
                </PanelFooter>
            </PanelContainer>
        </Overlay>
    );
};

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const PanelContainer = styled.div`
    background-color: ${({ theme }) => theme.cardBackgroundColor};
    border-radius: ${({ theme }) => theme.borderRadius};
    width: 90%;
    max-width: 500px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
`;

const PanelHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid ${({ theme }) => theme.lightBorderColor};
`;

const PanelTitle = styled.h2`
    margin: 0;
    font-size: 20px;
    font-weight: 600;
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: ${({ theme }) => theme.textColor};
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        color: ${({ theme }) => theme.ctaPrimaryColor};
    }
`;

const PanelContent = styled.div`
    padding: 20px;
    overflow-y: auto;
    flex-grow: 1;
`;

const Section = styled.div`
    margin-bottom: 24px;

    &:last-child {
        margin-bottom: 0;
    }
`;

const SectionTitle = styled.h3`
    font-size: 12px;
    font-weight: 700;
    color: #666;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0 0 12px 0;
`;

const LegendItem = styled.div`
    display: flex;
    align-items: center;
    padding: 8px 0;
`;

const Icon = styled.span`
    font-size: 20px;
    margin-right: 12px;
    min-width: 24px;
    text-align: center;
`;

const Label = styled.span`
    font-size: 14px;
    color: ${({ theme }) => theme.textColor};
`;

const PanelFooter = styled.div`
    padding: 20px;
    border-top: 1px solid ${({ theme }) => theme.lightBorderColor};
    display: flex;
    justify-content: center;
`;
